<template>
    <div class="time-picker">
        <div class="time">
            <v-icon @mousedown="increment('hour')"
                    @mouseup="stopInterval('increment','hour')"
                    @mouseleave="stopInterval('increment','hour')"
                    v-ripple>
                mdi-chevron-up
            </v-icon>
            {{textHour}}
            <v-icon @mousedown="decrement('hour')"
                    @mouseup="stopInterval('decrement','hour')"
                    @mouseleave="stopInterval('decrement','hour')"
                    v-ripple>
                mdi-chevron-down
            </v-icon>
        </div>
        <div class="separator">:</div>
        <div class="time">
            <v-icon @mousedown="increment('minutes')"
                    @mouseup="stopInterval('increment','minutes')"
                    @mouseleave="stopInterval('increment','minutes')"
                    v-ripple>
                mdi-chevron-up
            </v-icon>
            {{textMinutes}}
            <v-icon @mousedown="decrement('minutes')"
                    @mouseup="stopInterval('decrement','minutes')"
                    @mouseleave="stopInterval('decrement','minutes')"
                    v-ripple>
                mdi-chevron-down
            </v-icon>
        </div>
    </div>
</template>

<script>

    export default {
        name: "TimePicker",
        props: ['initialTime', 'value'],
        data: () => ({
            hour: 0,
            minutes: 0,
            step: 10,
            initialHourValue: null,
            initialMinutesValue: null
        }),
        mounted() {
            const timeArr = this.initialTime.split(':');
            this.hour = +timeArr[0];
            this.minutes = +timeArr[1];
            // Trimming single minutes, rounding to full 10
            this.minutes = Math.round(this.minutes / 10) * 10;
        },
        computed: {
            textHour: function () {
                return this.hour < 10 ? '0' + this.hour : this.hour
            },
            textMinutes: function () {
                return this.minutes < 10 ? '0' + this.minutes : this.minutes
            },
            time: function () {
                return `${this.textHour}:${this.textMinutes}`
            }
        },
        methods: {
            increment: function (type) {
                type === 'hour' ?
                    this.initialHourValue = this.hour
                    :
                    this.initialMinutesValue = this.minutes;

                const _self = this;
                this.interval = setInterval(function () {
                    type === 'hour' ?
                        _self[type] = +_self[type] + 1
                        :
                        _self[type] = +_self[type] + _self.step
                }, 150)
            },
            decrement: function (type) {
                this.initialMinutesValue = this.minutes;
                this.initialHourValue = this.hour;
                const _self = this;
                this.interval = setInterval(function () {
                    type === 'hour' ?
                        _self[type] = +_self[type] - 1
                        :
                        _self[type] = +_self[type] - _self.step
                }, 150)
            },
            stopInterval: function (type, unit) {
                clearInterval(this.interval);
                if (unit === 'hour') {
                    if (this.initialHourValue === this.hour) {
                        type === 'increment' ?
                            this.hour = +this.hour + 1
                            :
                            this.hour = +this.hour - 1
                    }
                } else {
                    if (this.initialMinutesValue === this.minutes) {
                        type === 'increment' ?
                            this.minutes = +this.minutes + this.step
                            :
                            this.minutes = +this.minutes - this.step
                    }
                }
            },
        },
        watch: {
            minutes: {
                handler: function (val, oldVal) {
                    if (+val >= 60) {
                        this.minutes = +val - 60;
                        this.hour += 1
                    } else if (+val < 0) {
                        this.minutes = 60 + +val;
                        this.hour -= 1
                    }
                }
            },
            hour: {
                handler: function (val, oldVal) {
                    if (+val >= 24) {
                        this.hour = 0;
                        this.$emit('dateChanged', 1)
                    } else if (+val < 0) {
                        this.hour = 23;
                        this.$emit('dateChanged', -1)
                    }
                }
            },
            time: {
                handler: function (val, oldVal) {
                    this.$emit('input', val)
                }
            }
        }
    }
</script>

<style scoped>

</style>
